module.exports = __webpack_public_path__ + "img/arrow-close.30f69ade.svg";